<template>
    <div 
        class="modal fade"
        id="addTipoEsercizioModal"
        tabindex="-1"
        aria-labelledby="addContact"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addContact">
                        {{isEdit ? 'Modifica' : 'Aggiungi'}} Tipologia di Test
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <form @submit.prevent="submit">
                <div class="modal-body">
                    <div class="col-md-12 text-start">
                        <label for="nome" class="form-label">Nome:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.nome ? true : false}" id="nome" v-model="form.nome" autofocus aria-describedby="nomeFeedback" required>
                            <div v-if="errors.nome" id="nomeFeedback" class="invalid-feedback">
                                {{errors.nome}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start">
                        <label for="valore_minimo" class="form-label">valore_minimo:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.valore_minimo ? true : false}" id="valore_minimo" v-model="form.valore_minimo" autofocus aria-describedby="valore_minimoFeedback">
                            <div v-if="errors.valore_minimo" id="valore_minimoFeedback" class="invalid-feedback">
                                {{errors.valore_minimo}}
                            </div>
                        </div>
                    </div> 
                    <div class="col-md-12 text-start">
                        <label for="valore_intermedio" class="form-label">valore_intermedio:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.valore_intermedio ? true : false}" id="valore_intermedio" v-model="form.valore_intermedio" autofocus aria-describedby="valore_intermedioFeedback">
                            <div v-if="errors.valore_intermedio" id="valore_intermedioFeedback" class="invalid-feedback">
                                {{errors.valore_intermedio}}
                            </div>
                        </div>
                    </div> 
                    <div class="col-md-12 text-start">
                        <label for="valore_massimo" class="form-label">valore_massimo:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.valore_massimo ? true : false}" id="valore_massimo" v-model="form.valore_massimo" autofocus aria-describedby="valore_massimoFeedback">
                            <div v-if="errors.valore_massimo" id="valore_massimoFeedback" class="invalid-feedback">
                                {{errors.valore_massimo}}
                            </div>
                        </div>
                    </div> 
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Annulla
                    </button>
                    <button type="submit" class="btn btn-primary" :disabled="form.processing">
                        {{isEdit ? 'Aggiorna' : 'Salva'}}
                    </button>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';

export default {
    props: {
        tipo_test: Object,
        isEdit: Boolean
    },
    data() {
        return {
            modal: null,
            form: this.$inertia.form({
                nome: this.tipo_test ? this.tipo_test.nome : "" ,
                valore_minimo: this.tipo_test ? this.tipo_test.valore_minimo : "",
                valore_intermedio: this.tipo_test ? this.tipo_test.valore_intermedio : "",
                valore_massimo: this.tipo_test ? this.tipo_test.valore_massimo : ""
            }),
            errors: {
               nome: null,
               valore_minimo: null,
               valore_intermedio: null,
               valore_massimo: null
            },
        };
    },
    mounted() {
        var modalEl = document.getElementById('addTipoEsercizioModal')
        this.modal = new Modal(modalEl)
        this.modal.show();
        
        modalEl.addEventListener('hidden.bs.modal',  (event) => {
            this.$emit('modelStatusChanged',false)
        })
    },
    methods: {
        close(){
            //this.isOpen = false
        },
        submit() {
            let route = this.isEdit ? this.route("tipo_test.update",this.paziente.id) : this.route("tipo_test.store")
            let method = this.isEdit ? 'patch' : 'post'
            this.form[this.isEdit ?'patch' : 'post'](route, {
                onError: (errors) => {
                    
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        
                        if (errors.hasOwnProperty("nome")) {
                            toast.message = errors.nome;
                            this.errors.nome = errors.nome;
                        }

                    }
                }, 
                onSuccess: () => {
                    this.form.reset();
                    this.modal.hide();

                }
            });
        },
    },
};
</script>
